import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { subscribeToWorkshopProject, useRealtimeStore } from "@/lib/socket";
import { workshopProjectResyncKeys } from "./workshopRealtime";

/**
 * Keeps this tab in the project's room while the project is open, so what
 * collaborators change (artifacts, ideas, context, media, files, agents,
 * members) arrives as it happens. Events are not replayed: every confirmed
 * (re)join refetches what was loaded before it.
 */
export function useWorkshopProjectRoom(projectId: string | null) {
  const qc = useQueryClient();
  const socket = useRealtimeStore((s) => s.socket);

  useEffect(() => {
    if (!socket || !projectId) return;
    return subscribeToWorkshopProject(socket, projectId, (since) => {
      for (const queryKey of workshopProjectResyncKeys(projectId)) {
        void qc.invalidateQueries({
          queryKey,
          predicate: (query) =>
            query.state.dataUpdatedAt > 0 && query.state.dataUpdatedAt < since,
        });
      }
    });
  }, [socket, projectId, qc]);
}
